import axios from "axios";

const token = localStorage.getItem("token");

const mainAxios = axios.create({
  baseURL: process.env.REACT_APP_ENDPOINT_URL,
  headers: {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  },
});

export const updateAxiosToken = () => {
  const token = localStorage.getItem("token");
  if (token) {
    mainAxios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete mainAxios.defaults.headers.common["Authorization"];
  }
};

export default mainAxios;
